<div class="container-fluid">
    <div class="row">
      <mat-label>
        {{ tab.msg }}
      </mat-label>
    </div>
  
    <div class="row" style="margin-top: 30px">
      <!-- <div class="col-lg-6">
              <button class="btn btn-outline-primary" mat-raised-button (click)="annuler()">ANNULER</button>
          </div> -->
      <div class="col-lg-6" style="margin: auto; width: 25%">
        <a
          class="btn-secondary"
          mat-raised-button
          style="margin-left: 10px;"
          (click)="fermer()">OK</a>
      </div>
    </div>
  </div>
  
